module.exports = function() {
  return !!navigator.userAgent.match(/i(phone|pad)/i);
}